<template>
  <q-layout>
    <app-header></app-header>
    <q-page-container>
      <router-view></router-view>
    </q-page-container>
    <app-footer></app-footer>
  </q-layout>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import AppHeader from './partials/AppHeader.vue';
import AppFooter from './partials/AppFooter';

@Component({
  name: 'DefaultLayout',
  components: { AppFooter, AppHeader },
})
export default class DefaultLayout extends Vue {}
</script>
